import Action from 'actions';
import BaseLP from 'services/sports/default/base-lp';
import {getSimplexUnitName} from 'helpers/simplex-helper';

export default class LpTiers extends BaseLP {
    createGroupsOfStacks({incomingValues: {dispatch}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        dispatch(Action.do('createGroupsOfPositionStacks', preparedPlayers.groupedBy.teamAndPosition()));
    }

    prepareGeneralSection({incomingValues = {}}) {
        const {
            playersData: {preparedPlayers},
        } = Action.getState();
        const playersIndexedById = preparedPlayers.groupedBy.playerId();

        return Object.values(playersIndexedById).map((player) => getSimplexUnitName(player.getId()));
    }

    subjectToPermanent() {
        const constraints = {
            projectedOwnershipCap: this.exec('projectedOwnership', {}, ''),
            tiers: this.exec('prepareSectionByTier', {}, ''),
            games: this.exec('prepareSectionByGame', {}, ''),
            keyPlayerStacking: this.exec('keyPlayerStacking', {}, ''),
            projectionBoostRule: this.exec('projectionBoostRule', {}, ''),
        };

        return {...constraints};
    }

    subjectToAlterable() {
        const constraints = {
            createdLineups: this.exec('prepareSectionByCreatedLineups_Tiers', {}, ''),
            exposureMax: this.exec('prepareSectionByExposureMax', {}, ''),
            exposureMin: this.exec('prepareSectionByExposureMin', {}, ''),
            playerCombinationStacking: this.exec('playerCombinationStacking', {}, ''),
        };

        return {...constraints};
    }
}
